import { render, staticRenderFns } from "./RoleAdd.vue?vue&type=template&id=6fa71650&scoped=true"
import script from "./RoleAdd.vue?vue&type=script&lang=js"
export * from "./RoleAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa71650",
  null
  
)

export default component.exports